import { Tab, Tabs } from "@mui/material";
import ErrorBoundary from "../Common/ErrorBoundary";
import TopBar from "../Common/TopBar";
import FieldAgentPendingReturnOrders from "./FieldAgentPendingReturnOrders";
import FieldAgentClosedReturnOrders from "./FieldAgentClosedReturnOrders";
import React from "react";
import AnalyticsService from "../../Services/AnalyticsService";
import InProgressReturnOrders from "./InProgressReturnOrders";
import { matchPath, useLocation, useNavigate } from "react-router-dom";

const RETURN_ORDER_TABS = [
  { name: "Pending", path: "/field-agent-returns" },
  { name: "In Progress", path: "/field-agent-returns/in-progress" },
  { name: "Closed", path: "/field-agent-returns/closed" },
];

export default function FieldAgentReturnOrderPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleTabClickedEvent = ({ name, path }) => {
    AnalyticsService.pushEvent(`Tab Clicked`, {
      tabName: name,
      page: "Agent Return Orders",
    });
    navigate(path, { replace: true });
  };

  function useRouteMatch(patterns) {
    for (let i = 0; i < patterns.length; i += 1) {
      const pattern = patterns[i];
      const possibleMatch = matchPath(pattern, pathname);
      if (possibleMatch !== null) {
        return possibleMatch;
      }
    }

    return null;
  }

  const routeMatch = useRouteMatch([
    "/field-agent-returns",
    "/field-agent-returns/in-progress",
    "/field-agent-returns/closed",
  ]);
  const currentTab = routeMatch?.pathname;

  return (
    <>
      <TopBar title="Return Orders" backNavigation={true} />

      <ErrorBoundary message={``}>
        <Tabs
          value={currentTab}
          sx={{
            background: "#ffffff",
            margin: "16px",
            marginBottom: "16px",
            padding: "0px 24px",
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.05)",
            borderRadius: "20px",
          }}
        >
          {RETURN_ORDER_TABS.map((tab) => (
            <Tab
              key={tab.name}
              label={tab.name}
              value={tab.path}
              sx={{
                width: "33.33%",
                borderBottom:
                  currentTab === tab.path ? "1px solid #9D2123" : "none",
                color: currentTab === tab.path ? "#9D2123" : "#333333",
                opacity: currentTab === tab.path ? "1" : "0.6",
                textTransform: "capitalize",
                fontSize: "14px",
                padding: "12px 8px",
              }}
              onClick={() => handleTabClickedEvent(tab)}
            />
          ))}
        </Tabs>
      </ErrorBoundary>
      {currentTab === RETURN_ORDER_TABS[0].path && (
        <FieldAgentPendingReturnOrders />
      )}
      {currentTab === RETURN_ORDER_TABS[1].path && <InProgressReturnOrders />}
      {currentTab === RETURN_ORDER_TABS[2].path && (
        <FieldAgentClosedReturnOrders />
      )}
    </>
  );
}
